<template>
	<div class="GNVPVGB-S-a">
		 <div class="GNVPVGB-fb-a">
			 <div class="GNVPVGB-fb-b"></div> 
			 <div class="GNVPVGB-fb-c"></div>
			</div> 
	</div>
</template>
<script>

export default {
	
}
</script>
